import RouteWrapper from 'components/App/RouteWrapper'
import React from 'react'
import useIsUserAuthenticated from 'hooks/useIsUserAuthenticated'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { Redirect, useLocation } from 'react-router-dom'


const PrivateRoute = (props) => {
  const { pathname } = useLocation()
  const isUserAuthenticated = useIsUserAuthenticated()
  const completedSupporterOnboarding = useCurrentUserProp('completedSupporterOnboarding')

  if(isUserAuthenticated) {
    if(!completedSupporterOnboarding && pathname !== '/supporter-onboarding') {
      return <Redirect to={{ pathname: '/supporter-onboarding'}} />
    }
    return <RouteWrapper { ...props } />
  }

  return <Redirect to={{ pathname: "/login", state: { from: { pathname } } }} />
}

export default PrivateRoute
